<template>
  <div class="container">
    <p>Use this pages to search for members.</p>

  </div>
</template>

<script>
    export default {
        name: "MemberIndex"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/member/MemberIndex.vue